import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import QDialog from "../dialog/QDialog.js";
import QBtn from "../btn/QBtn.js";
import clone from "../../utils/clone.js";
import { isKeyCode } from "../../utils/key-composition.js";
import QCard from "../card/QCard.js";
import QCardSection from "../card/QCardSection.js";
import QCardActions from "../card/QCardActions.js";
import QSeparator from "../separator/QSeparator.js";
import QInput from "../input/QInput.js";
import QOptionGroup from "../option-group/QOptionGroup.js";
import QSpinner from "../spinner/QSpinner.js";
import DarkMixin from "../../mixins/dark.js";
import AttrsMixin from "../../mixins/attrs.js";
import cache from "../../utils/cache.js";
export default Vue.extend({
  name: 'DialogPlugin',
  mixins: [DarkMixin, AttrsMixin],
  inheritAttrs: false,
  props: {
    title: String,
    message: String,
    prompt: Object,
    options: Object,
    progress: [Boolean, Object],
    html: Boolean,
    ok: {
      type: [String, Object, Boolean],
      default: true
    },
    cancel: [String, Object, Boolean],
    focus: {
      type: String,
      default: 'ok',
      validator: function validator(v) {
        return ['ok', 'cancel', 'none'].includes(v);
      }
    },
    stackButtons: Boolean,
    color: String,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  computed: {
    classes: function classes() {
      return 'q-dialog-plugin' + (this.isDark === true ? ' q-dialog-plugin--dark q-dark' : '') + (this.progress !== false ? ' q-dialog-plugin--progress' : '');
    },
    spinner: function spinner() {
      if (this.progress !== false) {
        return Object(this.progress) === this.progress ? {
          component: this.progress.spinner || QSpinner,
          props: {
            color: this.progress.color || this.vmColor
          }
        } : {
          component: QSpinner,
          props: {
            color: this.vmColor
          }
        };
      }
    },
    hasForm: function hasForm() {
      return this.prompt !== void 0 || this.options !== void 0;
    },
    okLabel: function okLabel() {
      return Object(this.ok) === this.ok ? this.$q.lang.label.ok : this.ok === true ? this.$q.lang.label.ok : this.ok;
    },
    cancelLabel: function cancelLabel() {
      return Object(this.cancel) === this.cancel ? this.$q.lang.label.cancel : this.cancel === true ? this.$q.lang.label.cancel : this.cancel;
    },
    vmColor: function vmColor() {
      return this.color || (this.isDark === true ? 'amber' : 'primary');
    },
    okDisabled: function okDisabled() {
      if (this.prompt !== void 0) {
        return this.prompt.isValid !== void 0 && this.prompt.isValid(this.prompt.model) !== true;
      }

      if (this.options !== void 0) {
        return this.options.isValid !== void 0 && this.options.isValid(this.options.model) !== true;
      }
    },
    okProps: function okProps() {
      return _objectSpread(_objectSpread({
        color: this.vmColor,
        label: this.okLabel,
        ripple: false
      }, Object(this.ok) === this.ok ? this.ok : {
        flat: true
      }), {}, {
        disable: this.okDisabled
      });
    },
    cancelProps: function cancelProps() {
      return _objectSpread({
        color: this.vmColor,
        label: this.cancelLabel,
        ripple: false
      }, Object(this.cancel) === this.cancel ? this.cancel : {
        flat: true
      });
    }
  },
  methods: {
    show: function show() {
      this.$refs.dialog.show();
    },
    hide: function hide() {
      this.$refs.dialog.hide();
    },
    getPrompt: function getPrompt(h) {
      var _this = this;

      return [h(QInput, {
        props: {
          value: this.prompt.model,
          type: this.prompt.type,
          label: this.prompt.label,
          stackLabel: this.prompt.stackLabel,
          outlined: this.prompt.outlined,
          filled: this.prompt.filled,
          standout: this.prompt.standout,
          rounded: this.prompt.rounded,
          square: this.prompt.square,
          counter: this.prompt.counter,
          maxlength: this.prompt.maxlength,
          prefix: this.prompt.prefix,
          suffix: this.prompt.suffix,
          color: this.vmColor,
          dense: true,
          autofocus: true,
          dark: this.isDark
        },
        attrs: this.prompt.attrs,
        on: cache(this, 'prompt', {
          input: function input(v) {
            _this.prompt.model = v;
          },
          keyup: function keyup(evt) {
            // if ENTER key
            if (_this.okDisabled !== true && _this.prompt.type !== 'textarea' && isKeyCode(evt, 13) === true) {
              _this.onOk();
            }
          }
        })
      })];
    },
    getOptions: function getOptions(h) {
      var _this2 = this;

      return [h(QOptionGroup, {
        props: {
          value: this.options.model,
          type: this.options.type,
          color: this.vmColor,
          inline: this.options.inline,
          options: this.options.items,
          dark: this.isDark
        },
        on: cache(this, 'opts', {
          input: function input(v) {
            _this2.options.model = v;
          }
        })
      })];
    },
    getButtons: function getButtons(h) {
      var child = [];
      this.cancel && child.push(h(QBtn, {
        props: this.cancelProps,
        attrs: {
          'data-autofocus': this.focus === 'cancel' && this.hasForm !== true
        },
        on: cache(this, 'cancel', {
          click: this.onCancel
        })
      }));
      this.ok && child.push(h(QBtn, {
        props: this.okProps,
        attrs: {
          'data-autofocus': this.focus === 'ok' && this.hasForm !== true
        },
        on: cache(this, 'ok', {
          click: this.onOk
        })
      }));

      if (child.length > 0) {
        return h(QCardActions, {
          staticClass: this.stackButtons === true ? 'items-end' : null,
          props: {
            vertical: this.stackButtons,
            align: 'right'
          }
        }, child);
      }
    },
    onOk: function onOk() {
      this.$emit('ok', clone(this.getData()));
      this.hide();
    },
    onCancel: function onCancel() {
      this.hide();
    },
    getData: function getData() {
      return this.prompt !== void 0 ? this.prompt.model : this.options !== void 0 ? this.options.model : void 0;
    },
    getSection: function getSection(h, staticClass, text) {
      return this.html === true ? h(QCardSection, {
        staticClass: staticClass,
        domProps: {
          innerHTML: text
        }
      }) : h(QCardSection, {
        staticClass: staticClass
      }, [text]);
    }
  },
  render: function render(h) {
    var _this3 = this;

    var child = [];
    this.title && child.push(this.getSection(h, 'q-dialog__title', this.title));
    this.progress !== false && child.push(h(QCardSection, {
      staticClass: 'q-dialog__progress'
    }, [h(this.spinner.component, {
      props: this.spinner.props
    })]));
    this.message && child.push(this.getSection(h, 'q-dialog__message', this.message));

    if (this.prompt !== void 0) {
      child.push(h(QCardSection, {
        staticClass: 'scroll q-dialog-plugin__form'
      }, this.getPrompt(h)));
    } else if (this.options !== void 0) {
      child.push(h(QSeparator, {
        props: {
          dark: this.isDark
        }
      }), h(QCardSection, {
        staticClass: 'scroll q-dialog-plugin__form'
      }, this.getOptions(h)), h(QSeparator, {
        props: {
          dark: this.isDark
        }
      }));
    }

    if (this.ok || this.cancel) {
      child.push(this.getButtons(h));
    }

    return h(QDialog, {
      ref: 'dialog',
      props: _objectSpread(_objectSpread({}, this.qAttrs), {}, {
        value: this.value
      }),
      on: cache(this, 'hide', {
        hide: function hide() {
          _this3.$emit('hide');
        }
      })
    }, [h(QCard, {
      staticClass: this.classes,
      style: this.cardStyle,
      class: this.cardClass,
      props: {
        dark: this.isDark
      }
    }, child)]);
  }
});